<script setup lang="ts">
import {useInterviewStore} from "@/stores/interview-store";
import {storeToRefs} from "pinia";

const interviewStore = useInterviewStore();
const {program} = storeToRefs(interviewStore);

// For now, we use the hardcoded id for the pregnancy program to determine which image to show, if other programs with
// different images are needed in the future we will manage those images with the api.
const pregnancyProgramIds = [35, 107];
</script>

<template>
  <div class="bg-white h-full flex items-center justify-center">
    <img
      v-if="program && pregnancyProgramIds.includes(program.id)"
      src="@/assets/images/vaccination-timeline-pregnant.png"
      alt="vaccination timeline"
    />
    <img
      v-else
      src="@/assets/images/vaccination-timeline.png"
      alt="vaccination timeline"
    >
  </div>
</template>

<style scoped>

</style>
